module.exports = __webpack_public_path__ + "static/media/text-reader.fa326479.jpg";